// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/**
 * Profanity option.
 * Added in version 1.7.0.
 */
export enum ProfanityOption {
    Masked = 0,
    Removed = 1,
    Raw = 2
}
